import React from 'react';

function CardHeader({ children, className }) {
  return (
    <div className={`w-full p-2 border-b ${className}`}>
      {children}
    </div>
  );
}

export default CardHeader;
